
import { computed, defineComponent, PropType, ref } from 'vue'
import { FreeSubscription } from '@/modules/free-subscriptions/types'
import { FreeSubscriptionsRouteNames } from '@/router/routes-names'
import { FreeSubscriptionSearchFilter } from '@/views/_shared/search-list/types'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { FormModelCacheTag } from '@/modules/_shared/forms'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useFreeSubscriptionsModule } from '@/modules/free-subscriptions'
import { useRoute, useRouter } from 'vue-router'
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'
import Uuid from '@/components/_shared/uuid.vue'
import { usePackageModule } from '@/modules/packages'
import { getPackageById, getPackagesList } from '../../modules/packages/api'

export default defineComponent({
    name: 'free-subscriptions-list',
    methods: { getPackageById },
    components: { Uuid },
    props: {
        freeSubscriptions: {
            type: Array as PropType<FreeSubscription[]>
        },
        filter: {
            type: Object as PropType<FreeSubscriptionSearchFilter>
        }
    },
    async setup (props) {
        const $q = useQuasar()
        const { getFreeSubscriptions, freeSubscriptionsFilter, freeSubscriptionsCount, deleteFreeSubscription } = useFreeSubscriptionsModule()
        const { getPackageNameById, getPackages } = usePackageModule()
        const router = useRouter()
        const route = useRoute()

        getPackages()

        const freeSubscriptionsColumns = ([
            { name: 'subscriptionId', label: 'Subscription id', field: 'subscriptionId', align: 'left' },
            { name: 'email', label: 'User email', field: 'email', sortable: true, align: 'left' },
            { name: 'subscriptionType', label: 'Subscription type', field: 'subscriptionType', sortable: true, align: 'left' },
            { name: 'processType', label: 'Process type', field: 'processType', sortable: true, align: 'left' },
            { name: 'packages', label: 'Packages', field: 'packages', align: 'left' },
            { name: 'createdBy', label: 'Created by', field: 'createdBy', sortable: true, align: 'left' },
            { name: 'startDate', label: 'Start Date', field: 'startDate', sortable: true, align: 'left' },
            { name: 'endDate', label: 'End Date', field: 'endDate', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        function onShowFreeSubscriptionRow (evt: PointerEvent | null, props: FreeSubscription) {
            router.push({ name: FreeSubscriptionsRouteNames.SHOW, params: { subscriptionId: props.subscriptionId }, query: { page: route.query.page } })
        }

        async function onDeleteFreeSubscriptionRow (freeSubscriptionRow: FreeSubscription) {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'free subscription',
                    identifier: freeSubscriptionRow.subscriptionId,
                    deleteCallback: async () => {
                        await deleteFreeSubscription(freeSubscriptionRow.subscriptionId)
                    }
                }
            })
        }

        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)

        const { loading, pagination, onRequest } = useAPIPagination(freeSubscriptionsFilter, getFreeSubscriptions, freeSubscriptionsCount, currentPage, false, FormModelCacheTag.FREE_SUBSCRIPTIONS_LIST_FILTERS)

        await onRequest({
            filter: props.filter || {
                subscriptionType: '',
                processType: '',
                createdBy: '',
                user: '',
                id: '',
                startDate: '',
                endDate: ''
            } as FreeSubscriptionSearchFilter,
            pagination: pagination.value
        })
        return {
            freeSubscriptionsColumns,
            onShowFreeSubscriptionRow,
            onDeleteFreeSubscriptionRow,
            loading,
            pagination,
            onRequest,
            getPackageNameById
        }
    }
})
